/**
 * Palavras que possuem uma grafia canônica fixa, independente da grafia de origem
 *
 * A chave deve estar em caixa alta e o valor deve ser a grafia canônica desejada.
 */
export const canonicals: Record<string, string> = {
  EMULTI: 'eMulti',
}
